import { render, staticRenderFns } from "./Products_SidebarRight.vue?vue&type=template&id=6658f186&"
import script from "./Products_SidebarRight.vue?vue&type=script&lang=js&"
export * from "./Products_SidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./Products_SidebarRight.vue?vue&type=style&index=0&id=6658f186&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports